import { createRouter, createWebHistory } from 'vue-router'
import CustomerLoginView from '../views/CustomerLoginView.vue'
import AdminLoginView from '../views/AdminLoginView.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import CustomerLayout from '../layouts/CustomerLayout.vue'

/** 管理员登录入口（故意使用不规则路径，勿在客户侧暴露） */
export const ADMIN_LOGIN_PATH = '/ops-entry/k7m2xq'

const routes = [
  { path: '/login', name: 'customer-login', component: CustomerLoginView },
  { path: ADMIN_LOGIN_PATH, name: 'admin-login', component: AdminLoginView },
  // 常见猜测路径不暴露管理入口
  { path: '/admin/login', redirect: '/login' },
  { path: '/admin', redirect: '/admin/dashboard' },
  { path: '/admin/:page?', name: 'admin', component: AdminLayout },
  { path: '/customer', name: 'customer', component: CustomerLayout },
  { path: '/', redirect: '/login' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const adminToken = localStorage.getItem('adminToken')
  const customerToken = localStorage.getItem('customerToken')

  if (to.name === 'admin-login') {
    if (adminToken) return '/admin/dashboard'
    return true
  }

  if (to.path === '/login') {
    if (customerToken) return '/customer'
    return true
  }

  if (to.path.startsWith('/admin') && !adminToken) return '/login'
  if (to.path.startsWith('/customer') && !customerToken) return '/login'
  return true
})

export default router
